<template>
    <th class="tw-p-2 tw-cursor-pointer hover:tw-bg-gray-100" @click="sortTable">
        <div class="tw-flex tw-items-center tw-justify-between tw-h-full">
            <div>
                <slot></slot>
            </div>

            <div class="tw-ml-2">
                <i class="fa fa-caret-up tw-block" :class="{ 'tw-text-gray-300':(active & this.currentDirection == 'desc') }"></i>
                <i class="fa fa-caret-down tw-block" :class="{ 'tw-text-gray-300':(active & this.currentDirection == 'asc') }"></i>
            </div>
        </div>
    </th>
</template>

<script>
export default {
    name: "DataTableColumn",

    props: {
        column: {
            type: String,
            required: true
        },
        direction: {
            type: String,
            default: 'desc'
        },
        initial: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            active: this.initial,
            currentDirection: this.direction
        }
    },

    computed: {
        newDirection() {
            if(this.active) {
                // If the column is the active column, flip the current direction
                return this.currentDirection == 'desc' ? 'asc' : 'desc';
            } else {
                // If the column is not the active column, sort by the initial direction
                return this.direction;
            }
        },
    },

    methods: {
        update(value) {
            // Before updating the active status, determine the direction that will be displayed
            this.currentDirection = this.newDirection;

            this.active = value;
        },

        sortTable() {
            this.$emit('sort', { column: this.column, direction: this.newDirection });
        }
    }
}
</script>

<style>

</style>